import React, { SetStateAction, useEffect, useState } from "react";
import UserApi from "../../api/UserApi";
import { useDispatch } from "react-redux";
import { deleteUserCredential, saveUserCredential } from "../../redux/actions/LocalUserActions";
import { UserCredential } from "../../Model/User";
import { useHistory } from "react-router-dom";
import UserCredentialUtil from "../../Utility/UserCredentialUtil";
import config from "../../config";
import { authenticationEnable } from "../../redux/actions/AuthenticationSettingAction";
import { IsAuthenticationEnabled } from "../../Model/AuthenticationSetting";
import { removeNotification } from "../../redux/actions/NotificationAction";

type Props = {
  setShowLoading: React.Dispatch<SetStateAction<boolean>>;
  setShowErrorNotification: React.Dispatch<SetStateAction<boolean>>;
};

export default function AutoLogin({
  setShowLoading,
  setShowErrorNotification,
}: Props) {

  const dispatch = useDispatch();
  const history = useHistory();
  const autoLoginUserName = "Administrator";
  const [userCredential, setUserCredential] = useState({} as UserCredential);


  const getAutoLoginUserCredential = () => {
    UserApi.getUserCredential(autoLoginUserName)
      .then((result) => {
        setUserCredential(result);
      })
      .catch((error) => {
        //Failed to get user credential, because server suddenly enable authentication, and ui is not refresh
        //dircetly update authentication setting in UI to enable, and go to login page to force user is do login ,because current token is expired
        updateAuthenticationEnableSetting();
      });
  }

  const updateAuthenticationEnableSetting = () => {
    let authenticationSetting: IsAuthenticationEnabled = { enable: true };
    dispatch(authenticationEnable(authenticationSetting));
    dispatch(removeNotification());
  }

  const login = (userCredential: UserCredential) => {
    UserApi.login(userCredential)
      .then((result) => {
        dispatch(saveUserCredential(userCredential));
        history.push("/");

      })
      .catch((error) => {
        setShowErrorNotification(true);
      });
  };
  const authenticate = () => {
    setShowLoading(true);
    var userName = autoLoginUserName;
    var password = "";
    UserApi.authenticate(userName, password)
      .then((result) => {
        login(result);

      })
      .catch((error) => {

      });
  };
  const loggedOutCurrentSession = () => {
    UserApi.logout();
    dispatch(deleteUserCredential());
  }

  useEffect(() => {
    getAutoLoginUserCredential();
  }, []);

  useEffect(() => {
    if (JSON.stringify(userCredential) == JSON.stringify({} as UserCredential))//user credential not update from backend
      return;

    if (userCredential.token === "" || userCredential.token === undefined || userCredential.token === null || isTokenExpired(userCredential)) {
      //token not found, do authentication
      reauthenticateAutoLoginUser();
    } else {
      dispatch(saveUserCredential(userCredential));
    }
  }, [userCredential])

  const reauthenticateAutoLoginUser = () => {
    //loggedOutCurrentSession();
    dispatch(deleteUserCredential());
    authenticate();
  }

  const isTokenExpired = (user: UserCredential) => {
    let tokenExpiretOffset = 10;// do refresh before  UserActivityWatcher.tsx doing token update
    let expiredTime: Date | undefined = UserCredentialUtil.getUserExpiredTime(user);
    expiredTime?.setSeconds(expiredTime?.getSeconds() - config.REFRESH_TOKEN_BEFORE_EXPIRED_IN_SECONDS - tokenExpiretOffset);
    let currentTime: Date = new Date();

    if (expiredTime != undefined && expiredTime < currentTime)
      return true;
    else
      return false;
  }
  return (
    <></>
  );
}
